<template>
	<view class="box">
		<view class="box_item" v-for="(item, index) in 3" :key="index">
			<view class="box_item_top">
				<text>隐私权政策</text>
				<uni-icons type="forward" size="20" color="#CCCCCC"></uni-icons>
			</view>
			<!-- <view class="box_item_content">1234321234321</view> -->
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				
			}
		}
	}
</script>

<style>
	page {
		background-color: #fff !important;
	}
</style>

<style lang="scss" scoped>
	.box {
		width: 100%;
		padding: 0 32rpx;
		box-sizing: border-box;
		.box_item {
			display: flex;
			justify-content: center;
			flex-direction: column;
			padding: 32rpx 0;
			box-sizing: border-box;
			border-bottom: 2rpx solid #F4F5F4;
			.box_item_top {
				display: flex;
				align-items: center;
				justify-content: space-between;
				text {
					font-size: 32rpx;
					font-family: PingFang SC-Medium, PingFang SC;
					font-weight: 500;
					color: #333333;
				}
			}
			.box_item_content {
				padding: 20rpx 0;
				box-sizing: border-box;
				font-size: 24rpx;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #CCCCCC;
			}
		}
	}
</style>